@if (imageDetail(); as image) {
  <!-- Div contains black overlay -->
  <div
    class="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4"
    (click)="closePreview()"
    (keydown.esc)="closePreview()"
    tabindex="0"
  >
    <!-- Close button -->
    <button
      class="absolute top-4 right-4 md:top-24 md:right-12 bg-ss-gold text-white rounded-full w-10 h-10 flex items-center justify-center hover:bg-ss-gold/90 transition-colors text-2xl z-50"
      (click)="closePreview()"
      (keydown.enter)="closePreview()"
      aria-label="Close preview"
    >
      ×
    </button>
    <!-- Image container -->
    <div
      class="relative w-[98vh] md:w-[90vw] min-h-[45vh] md:min-h-[75vh] flex items-center justify-center"
    >
      @if (image.type?.includes('video')) {
        <video
          [src]="assetsBaseUrl + '/' + (image.id ?? image)"
          [attr.aria-label]="image.description || 'Video preview'"
          class="w-auto h-auto object-contain drop-shadow-2xl max-w-[85vw] xl:max-w-[65vw] max-h-[75vh]"
          controls
          playsinline
          (loadeddata)="imageLoaded.set(true)"
          (error)="imageError.set(true)"
          (click)="$event.stopPropagation()"
          (keydown.enter)="$event.stopPropagation()"
          tabindex="0"
        ></video>
      } @else {
        <img
          [ngSrc]="image.id ?? image"
          [alt]="image.description || 'Image'"
          (load)="imageLoaded.set(true)"
          (error)="imageError.set(true)"
          [sizes]="optimizedImageSizes[desktopImageSize()]"
          [loaderParams]="{ modifiedDate: image.modified_on }"
          [priority]="true"
          fill
          class="object-contain drop-shadow-2xl"
          (click)="$event.stopPropagation()"
          (keydown.enter)="$event.stopPropagation()"
          tabindex="0"
        />
      }
      <!-- Loading spinner -->
      @if (!imageLoaded() && !imageError()) {
        <div [@fadeInOut] class="absolute h-full w-full">
          <ss-spinner
            class="absolute inset-0 flex items-center justify-center"
          ></ss-spinner>
        </div>
      }
    </div>
  </div>
  @if (isDownloadable()) {
    <!-- download button -->
    <div
      class="fixed bottom-5 xl:bottom-8 z-50 w-full flex items-center justify-center"
    >
      <a
        href="{{ assetsBaseUrl }}/{{
          downloadDetail()?.id ?? image.id
        }}?download={{
          downloadDetail()?.filename_download ?? image.filename_download
        }}"
        target="_blank"
        [download]="
          downloadDetail()?.filename_download ?? image.filename_download
        "
        ><ss-button
          class="download-link-button"
          buttonColor="accent"
          buttonStyle="filled"
          >Download</ss-button
        ></a
      >
    </div>
  }
}
